import { Component, Input } from "@angular/core";
import "./veriBadge.scss";

@Component({
    selector: "veri-badge",
    template: require('./veriBadge.html')
})

export class VeriBadgeComponent{

    @Input('count')count: number;  

    constructor() {
      
    }   
}


